import React, { useEffect, useState } from 'react';
import { Navbar } from '../../Navbar';
import { useHistory } from 'react-router';
import { toast } from "react-toastify";
import useFetchApi from '../../../services/CustomHook/useFetchApi';
import swal from 'sweetalert';
import CashFlowWorkingTable from './CashFlowWorkingTable';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Loading from '../../Common/Loader/Loading';
import { socket } from '../../../services/socket/socket';
import { useDispatch, useSelector } from 'react-redux';
import ScrollTopTab from '../../Common/ScrollTopTab';
import PrimaryButton from "../../Common/PrimaryButton";
import { convertStrToNumber } from '../../../helper/ConvertValue';
import { cashflowAddNewLineItem } from '../../../services/api/apiHandler';
import NewOptionModal from './NewOptionModal';
import { addNewWorkingOption } from '../../../services/api/StandAlone/cashFlow';




///////////////////////////////////////////////////////////////////////////////////////////////////
import Sidebar from "../../../myfin_v2/elements/Sidebar";
import workSpaceCss from "../../../myfin_v2/css/workSpaceOverView.module.css"
import sidemenucss from "../../../myfin_v2/css/sidemenu.module.css";
// import FSSideMenu from "../../../myfin_v2/components/fs/FSSideMenu";
// import FSTopBar from "../../../myfin_v2/components/fs/FSTopBar";
import bookclosurecss from "../../../myfin_v2/css/bookclosure.module.css"
import { motion } from "framer-motion";
import commoncss from "../../../myfin_v2/css/common.module.css"
import { Tabs, Tab, Typography, Box } from "@mui/material";
/////////////////////
import buttoncss from "../../../myfin_v2/css/button.module.css"
import {Button} from "../../../myfin_v2/elements/Button";
import FSCss from "../../../myfin_v2/css/overview.module.css"
import loanCss from "../../../myfin_v2/css/overview.module.css"
import {ReactComponent as Plus} from "../../../myfin_v2/assets/icons/plus.svg"
import {ReactComponent as LeftArrowIcon} from "../../../myfin_v2/assets/icons/left_arrow.svg"



const CashFlowWorking = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const project_id = localStorage.getItem('project_id');
    const tb_id = localStorage.getItem('tb_id');
    const user = JSON.parse(localStorage.getItem('user'));
    const { loading, response, error } = useFetchApi(`api/v1/cashflow/${project_id}/${tb_id}`);

    const { fcRawData } = useSelector((state) => state.CashflowReducer);

    const [cashFlowWorking, setCashFlowWorking] = useState([]);
    const [project, setProject] = useState({});
    const [workingOpt, setWorkingOpt] = useState([]);
    const [faceValueData, setFaceValueData] = useState([]);
    const [open, setOpen] = useState(false);
    const [workingOptDetail, setWorkingOptDetail] = useState({
        newOptName: ''
    });
    
    const FSSideMenu = ({ menuItems, title, activeItem, activeItemSubMenu }) => {
      const dispatch = useDispatch();
      console.log("activeItem",activeItem);
      
      const [openSubmenu, setOpenSubmenu] = useState(activeItem);
    
      const routerHistory = useHistory();
    
      const handleClick = (Link) => {
        if (Link) {
          routerHistory.push(Link);
        }
      };
    
      return (
        <div
          className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}
        >
          <div className={sidemenucss.sidemenuHeader}     style={{ minHeight: "15vh" }}>
            <span className={sidemenucss.sidemenuTitle}>{title}</span>
            {/* <span className={sidemenucss.sidemenuSubTitle}>workspace name</span> */}
          </div>
          <div
            className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop} pt-0`}
          >
            <ul className={sidemenucss.sidemenuList}>
              {menuItems.map((item, index) => (
                <div key={index}>
                  <li
                    // onClick={() => {
                    //   // Toggle submenu visibility if the item has submenus
                    //   if (item.subMenu) {
                    //     setOpenSubmenu(openSubmenu === item.label ? null : item.label);
                    //   } else {
                    //     // Navigate if it's a top-level item without submenus
                    //     handleClick(item.pagelink);
                    //   }
                    // }}
                    // onClick={() => dispatch({ type: "NOTE_KEY", payload: index })}
                     onClick={() => {
    dispatch({ type: "NOTE_KEY", payload: index });
    handleClick(item.pagelink || "/financialstatement");
  }}
                    className={`${sidemenucss.sidemenuItem} ${
                      activeItem === index
                        ? sidemenucss.sidemenuItemActive
                        : ""
                    }`}
                  >
                    <span className={sidemenucss.sidemenuItemname}>
                      <div className={sidemenucss.sideMenuItemContainer}>
                        {item.label}
                      </div>
                    </span>
                  </li>
    
                  {item.subMenu && openSubmenu === item.label && (
                    <div className={sidemenucss.submenuContainer}>
                      {item.subMenu.map((sub, idx) => (
                        <div
                          key={idx}
                          className={`${sidemenucss.submenuItem} ${
                            activeItemSubMenu === sub.label
                              ? sidemenucss.activeSubMenu
                              : null
                          }`}
                          onClick={() => handleClick(sub.pagelink)}
                        >
                          {sub.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </ul>
          </div>
        </div>
      );
    };
    
    const FSTopBar = ({
            // setLoanUploadModal,
            ShowInDecimals,
            setShowInDecimals,
            //  history,
            softDeletedData,
            deleteItemsModel,
            setDeleteItemsModal,
            handleDelete,
            setHandleDelete
        }) => {
            const history=useHistory();
        return(
            
            <div className={FSCss.w100}>
    
                <div className={FSCss.uploadLoansMainContainer}>
                
                </div>
    
                <div className={FSCss.listPageheader}>
                    <div className={FSCss.headerLeftContainer}>
                        {/* <div className={FSCss.heading}>Loan Listing</div> */}
                        {/* <div className={FSCss.heading}  > */}
                            
                            <div className={FSCss.iconContainer}>
                                {/* <SearchIcon/> */}
                                <LeftArrowIcon className="clickable"
                                //   onClick={redirectToBookClosureHome}
                                 onClick={() => {dispatch({ type: "NOTE_KEY", payload: 2 }); history.push(`/financialstatement`) }}
                                />
                            </div>
                            <div className={FSCss.topBarHeading} style={{"align-content": "center"}}>Cashflow Working</div>
                           
                        {/* </div> */}
                    </div>
                    <div className={FSCss.headerRightContainer}>
                        
                        {/* <div className={FSCss.filterContainer}>
                            <FilterIcon />
                        </div> */}
    
                        {/* <div className={FSCss.filterContainer}>
                            <span className="module-toggles">
                                <div className="toggle-item">
                                    <div className="toggle-container">
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                checked={ShowInDecimals}
                                                // onChange={() => setShowInDecimals(!ShowInDecimals)}
                                            />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                            </span>
                            {/* &nbsp; */}
                            {/* &nbsp; */}
                            {/* Ind AS Impact */}
                            {/* <span className={FSCss.decimalLabel}>Show in Decimals</span>
                        </div>  */}
    
                        {/* <div className={FSCss.calenderContainer}>
                            <div className={FSCss.leftCalenderContainer}>
                                <div className={FSCss.calenderLabels}>
                                    From
                                </div>
                                <div className={FSCss.calenderDate}>
                                    01-01-2024
                                </div>
                                <div className={FSCss.calenderIconContainer}>
                                    <CalenderIcon />
                                </div>
                            </div>
    
                            <div className={FSCss.RightCalenderContainer}>
                                <div className={FSCss.calenderLabels}>
                                    To 
                                </div>
                                <div className={FSCss.calenderDate}>
                                    01-03-2024
                                </div>
                                <div className={FSCss.calenderIconContainer}>
                                    <CalenderIcon />
                                </div>
                            </div>
                        </div> */}
                        {/* <div className={FSCss.TopbtnWrapper}>
                            <button
                                onClick={() => {setLoanUploadModal(true);}} 
                                type="button" 
                                className={FSCss.linkRegisterButton}> 
                                
                             
                                Link Registers
                            </button>
                        </div>
                        <div className={FSCss.TopbtnWrapper}>
                            <button
                                onClick={() => {setLoanUploadModal(true);}} 
                                type="button" 
                                className={FSCss.FinalseBtn}> 
                                
                                Finalise FS
                            </button>
                        </div> */}
                        <Button
                    btnColor={buttoncss.secondary}
                    label="Adjustment Log"
                    // onClick={() => {
                    //     // history.push('/link-register')
                    // //   handleNew();
                    // }}
                     onClick={() => history.push('/financialstatement/cashflow/adjustment-log')}
                  />
                    &ensp;
                   {/* <Button
                      btnColor={buttoncss.primary}
                      label="Add New Adjustment"
                    //   onClick={handleFilter}
                    //  onClick={() => {
                    //     history.push('/finalize-fs')
                    // //   handleNew();
                    // }}
                    
                    />  */}
                      <div className={loanCss.btnWrapper}>
                                            <button
                                                // onClick={() => {setLoanUploadModal(true);}} 
                                                onClick={() => history.push('/financialstatement/cashflow/add-new-adjustment')}
                                                type="button" 
                                                style={{minWidth: '12rem'}}
                                                className={loanCss.uploadPrimaryBtn}> 
                                                <Plus className={`${loanCss.plusIcon}`} /> 
                                                {/* <span style={{ fontSize: '15px' }}>+</span>
                                                &nbsp; */}
                                                Add New Adjustment
                                            </button>
                                        </div>
                    
                    </div>
                </div>
            </div>
        )
    };

    function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div

      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
      const financialStatementTabs = ["Balance Sheets", "P&L Statement", "CashFlow", "SOCIE", "General Notes", "Balance Sheet Notes", "PNL Statement Notes", "Disclosures", "Disclosures Checklist"];
     const presetNoteKey = useSelector((initialState) => initialState.HandlePopulateFsNotesReducer.noteKey);
      const menuItems = [
    { label: "Balance Sheet", value: "Balance Sheets" , pagelink: "/financialstatement"},
    { label: "P&L Statement", value: "P&L Statement", pagelink: "/financialstatement"},
    { label: "CashFlow", value: "CashFlow", pagelink: "/financialstatement"},
    { label: "SOCIE", value: "SOCIE", pagelink: "/financialstatement"},
    { label: "General Notes", value: "General Notes", pagelink: "/financialstatement"},
    { label: "Balance Sheet Notes", value: "Balance Sheet Notes", pagelink: "/financialstatement"},
    { label: "PNL Statement Notes", value: "PNL Statement Notes", pagelink: "/financialstatement"},
    { label: "Disclosures", value: "Disclosures", pagelink: "/financialstatement"},
    { label: "Disclosures Checklist", value: "Disclosures Checklist", pagelink: "/financialstatement"},
  ];

    useEffect(() => {
        if (response && Object.keys(response).length > 0) {
            dispatch({ type: "CASHFLOW_FV_RAW_DATA", payload: response.data.rawFaceValueData || [] });
            setWorkingOpt(response?.data?.cashflowWorkingOptions);
            setCashFlowWorking(response?.data?.working);
            setFaceValueData(response?.data?.data);
            setProject(response?.data?.project);
        }
        if (error) {
            swal("Error", error, "error");
        }
    }, [response || error])


    const HandleChange = async (working_id, index, event) => {
        const copy = [...cashFlowWorking]
        // const nbfc_working_id_set = new Set([15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26,27, 28, 30, 32]);
        // const working_id_set = new Set([15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26,27]);

        // const WORKING_ID_SET = project?.company_type === "NBFC" ? nbfc_working_id_set : working_id_set;
        const getWorkingTable = copy.find(ele => ele.workingId === working_id);
        const tableName = getWorkingTable.tableName;
        const workingLabel1 = getWorkingTable?.data;
        workingLabel1[index][event.target.name] = convertStrToNumber(event.target.value);
        const key_amount = event.target.name === "cy" ? "cy_amount" : "py_amount";

        if(project?.company_type === "NBFC" && working_id === 32 && workingLabel1[index].adjustmentsName === "Less: Amortization"){
            workingLabel1[index][key_amount] = -1 * convertStrToNumber(event.target.value);
        }else{
            workingLabel1[index][key_amount] = 
                tableName === "lability" ? convertStrToNumber(event.target.value) : 
                -1 * convertStrToNumber(event.target.value);
        }

        const newFormula = (formula) => formula.split('-').map(Number).map(num => num - 1);

        const computeValue = (data, indices, field) => {
            if (!Array.isArray(data) || data.length === 0) return 0; // or handle the case when data is not an array or is empty
            const result = indices.reduce((acc, index, idx) => acc - (data[indices[idx + 1]]?.[field] || 0), data[indices[0]]?.[field] || 0);
            return { result, sign_result: 
                tableName === "lability" ? result : -result 
            };
        };

        if(working_id === 1){
            workingLabel1.forEach(workEle => {
                if(workEle.internalFormulaReference && workEle.internalFormulaReference !== "NA"){
                    let calculation_value;
                    if (
                        ['Net book value of sale madee', 'Sale value'].includes(workEle.adjustmentsName)
                    ) {
                        const indices = workEle.adjustmentsName === 'Sale value' ? 
                            workEle.internalFormulaReference.split("+").map(Number).map(num => num - 1) : [2, 4] ;

                        let calculated_value = workEle.adjustmentsName !== 'Sale value'
                            ? -(workingLabel1[2][event.target.name] || 0) - (workingLabel1[4][event.target.name] || 0)
                            : indices.reduce((accumulator, index) => accumulator + workingLabel1[index][event.target.name], 0);
                        calculated_value = calculated_value === -0 ? 0 : calculated_value
                        calculation_value = { result: calculated_value, sign_result: calculated_value }
                    }else{
                        calculation_value = computeValue(workingLabel1, newFormula(workEle.internalFormulaReference), event.target.name);
                    }
                    workEle[event.target.name] = calculation_value?.result;
                    workEle[key_amount] = calculation_value?.sign_result;
                }
            })
        }else{
            const filterByFormula = workingLabel1.find(ele => ele.internalFormulaReference && ele.internalFormulaReference !== "NA");
            const indexByFormula = workingLabel1.findIndex(ele => ele === filterByFormula);

            const calculation_value = computeValue(workingLabel1, newFormula(filterByFormula.internalFormulaReference), event.target.name);
            workingLabel1[indexByFormula][event.target.name] = calculation_value?.result;
            workingLabel1[indexByFormula][key_amount] = calculation_value?.sign_result;
        }   

        setCashFlowWorking(copy);

        //? Socked code for update and error handeling
        socket.emit("auto-save-cashflow-working", {
            project_id: `${project_id}`,
            contents: copy,
        });
    }
    socket.on('auto-save-cashflow-working', (data) => {
        // console.log('Message from server:', data);
        if(!data.success){
            swal("Error", data.message, "error")
        }
    });

    const AddNewLineItem = (index) => {
        if(user.responsibilities === "view"||user.responsibilities === "approver"){
            swal("Warning","You Don't have access to add newLine items","warning");
            return false;
        }
        cashflowAddNewLineItem({project_id, index}).then(response => {
            toast.success(response.data?.message || "New Item Added Successfully");
            setCashFlowWorking(response.data?.workingData)
            setFaceValueData(response.data?.fvData)
        }).catch(error => {
            swal("Error", error, "error");
        });
    }
     const HandleAddNewLine = (index) => {
    // This is the function that will be passed
    console.log("New line item will be added at index:", index);
    // Add your logic here to update the state or call an API
  };
  

    const HandleSelect = (e, index, sub_index) => {
        const {value, name} = e.target;
        let copy = [...cashFlowWorking];
        const deepCopy = JSON.parse(JSON.stringify(cashFlowWorking));
        if(value === "add-new-option"){
            setWorkingOptDetail(prev => ({...prev, index, sub_index, name }))
            setOpen(true);
            return;
        }

        const convertValue = name === "adjustmentCashFlowStatement" ? Number(value) : value;

        if(name === "nameOfItemCashFlowStatement"){
            const wantToRemoveWorkingId = deepCopy[index].workingId;
            const prevCSName = deepCopy[index].data[sub_index].nameOfItemCashFlowStatement;
            // ? Update Working ID
            faceValueData.forEach((ele, fvIndex) => {
                const findPreviousFD = ele.faceValueData.find(fd => fd.particular === prevCSName);
                const findFD = ele.faceValueData.find(fd => fd.particular === convertValue);
                
                if(findFD && findFD?.workingId){
                    findFD.workingId.push(copy[index]?.workingId || "");
                }
                if(findPreviousFD && findPreviousFD?.workingId){
                    const rawDataWorkingIds = fcRawData[fvIndex].faceValueData.find(fd => fd.particular === prevCSName).workingId ?? [];
                    const indexOfWA = findPreviousFD.workingId.indexOf(wantToRemoveWorkingId);
                    findPreviousFD.workingId = findPreviousFD.workingId.filter((ele, ex) => ex !== indexOfWA ); //? remove existing working id
                }
            })
            setFaceValueData(faceValueData);
        }

        copy[index].data[sub_index][name] = convertValue;

        setCashFlowWorking(copy);

        socket.emit("auto-save-cashflow-working", {
            project_id: `${project_id}`,
            contents: copy,
            faceValueData
        });
    }

    const addNewOption = () => {
        addNewWorkingOption({...workingOptDetail, project_id}).then(response => {
            setCashFlowWorking(response?.data?.working);
            setWorkingOpt(response?.data?.options);
            setWorkingOptDetail(prev => ({...prev, newOptName:"" }));
            setOpen(false);
        }).catch(error => {
            swal("Error", error?.response?.data?.message || "New Working Option Add failed.", "error");
        })
    }

    return (
        <>
{/* 
            <Sidebar/>
            <FSSideMenu title="Financial Statements" menuItems={menuItems} activeItem={presetNoteKey} /> */}

             <div className={`${workSpaceCss.df}`} >
                    <Sidebar />
                    <div className={`d-flex ${commoncss.pageContent}`}>
                      <motion.div
                        initial={{ x: -100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: 100, opacity: 0 }}
                        transition={{ duration: 0.5, ease: "easeInOut" }}
                      >
                        <FSSideMenu title="Financial Statements" menuItems={menuItems} activeItem={2} />
                      </motion.div>
                      <div className={bookclosurecss.bookClosureContent}>
                        <div className={`${bookclosurecss.bookClosureHeader} p-0`}>
                          <FSTopBar  />
                           {
                    loading ? <Loading /> :
                        <div style={{height: "88vh", overflow: "auto"}} className='p-2'>
                            {cashFlowWorking && cashFlowWorking.length > 0 && cashFlowWorking.map((ele, ix) => (
                                <div key={ele.workingId} style={{margin: "1rem"}} className={` bg-white `}>
                                   {ix === 0 &&(
                                    <CashFlowWorkingTable 
                                        // ele={ele}
                                        // data={ele.data}
                                        HandleSelect={HandleSelect}
                                        addNewOption={addNewOption}
                                        workingOpt={workingOpt}
                                        allData={cashFlowWorking}
                                        HandleChange={(index, event) => { HandleChange(ele.workingId, index, event) }}
                                        index={ix}
                                         AddNewLineItem={AddNewLineItem}
                                         HandleAddNewLine={HandleAddNewLine}
                                    />
                                   )}
                                    {/* <div className='w-100 py-2 ml-0 custom-bg-warning d-flex justify-content-between align-items-center'>
                                        <p className='font-size-14 custom-font-600 p-0 m-0 pl-2' >{ele.name}</p>
                                        <button 
                                            className='font-size-14 custom-font-600 custom-common-theme-text-color bg-color-inherit border-0 pr-2' 
                                            onClick={() => AddNewLineItem(ix)}
                                        >
                                            New line item +
                                        </button>
                                    </div> */}
                                    
                                    
                                    
                                </div>

                            ))}
                        </div>
                }
                        </div>
                       
                      </div>
                    </div>
            
                  </div>
            
            
            {/* <Navbar text="Financial Year: 2021 - 2022" />
            <div className='custom-common-secondary-bg'>
                <div className='d-flex w-100'>
                    <button className='ml-2 my-2 rounded back-btn' style={{ border: "none", backgroundColor: "inherit" }}
                        onClick={() => {dispatch({ type: "NOTE_KEY", payload: 2 }); history.push(`/financialstatement`) }}
                    >
                        <div className='d-flex px-3' style={{ color: "#03565a", fontWeight: "600" }}><ArrowBackIcon /> Back</div>
                    </button>

                    <div className='d-flex justify-content-center w-100 mt-2' style={{ gap: "1rem" }}>
                         <PrimaryButton name="Adjustment log" variant={"outlined"}  onClick={() => history.push('/financialstatement/cashflow/adjustment-log')} />
                         <PrimaryButton name="Add new adjustment" variant={"outlined"} onClick={() => history.push('/financialstatement/cashflow/add-new-adjustment')} />
                    </div>
                </div>
                {
                    loading ? <Loading /> :
                        <div className='p-2'>
                            {cashFlowWorking && cashFlowWorking.length > 0 && cashFlowWorking.map((ele, ix) => (
                                <div key={ele.workingId}  className={`nbfc-box-shadow bg-white `}>
                                   {ix === 0 &&(
                                    <CashFlowWorkingTable 
                                        // ele={ele}
                                        // data={ele.data}
                                        HandleSelect={HandleSelect}
                                        addNewOption={addNewOption}
                                        workingOpt={workingOpt}
                                        allData={cashFlowWorking}
                                        HandleChange={(index, event) => { HandleChange(ele.workingId, index, event) }}
                                        index={ix}
                                    />
                                   )}
                                    <div className='w-100 py-2 ml-0 custom-bg-warning d-flex justify-content-between align-items-center'>
                                        <p className='font-size-14 custom-font-600 p-0 m-0 pl-2' >{ele.name}</p>
                                        <button 
                                            className='font-size-14 custom-font-600 custom-common-theme-text-color bg-color-inherit border-0 pr-2' 
                                            onClick={() => {
                                                console.log("AddNewLineItem", ix)
                                                AddNewLineItem(ix) 
                                            } }
                                            
                                        >
                                            New line item +
                                        </button>
                                    </div>
                                    
                                    
                                    
                                </div>

                            ))}
                        </div>
                }
                <ScrollTopTab/>
            </div>
            <NewOptionModal
                open={open}
                setOpen={setOpen}
                setWorkingOptDetail={setWorkingOptDetail}
                workingOptDetail={workingOptDetail}
                addNewOption={addNewOption}
            /> */}
        </>
    )
}

export default CashFlowWorking